// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class AddBuddy extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        venue: this.props.venue,
        buddy_details: {
            user_id:'',
            mobile_no:'',
            name: '',
            role:0,
            department:0,
            games:[],
            display_name:'',
            is_active:false
        },
        departments_arr:[], 
        role_arr: [],
        game_types: [],
        user_search_list: [],
        temp_list_game: [],
        dialog_open_buddy:true,
        search: false,
        success:false,
        message:'',
        value_set:false
      };
      this.searchUser = this.searchUser.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleUserSubmit = this.handleUserSubmit.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      // this.handleVenueChange = this.handleVenueChange.bind(this)
    }
  
  componentDidMount() {
      this.getDetails();
  }  

  getDetails(){
  const url = `${getLocationOrigin()}/buddy/get_details_for_buddy_addition`;
  const options = {...defaultOptions};

  return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
          if(data.success){
            this.setState({success:data.success,role_arr:data.buddy_types,departments_arr:data.departments,game_types:data.game_types})
          }
          else{
            this.setState({success:data.success,message:data.message})
            alert(data.message)
          }
         // alert("fix");
     }).catch(error => error);
  }

  postUpdateBooking(details,venue,props) {
      console.log(details)
      const url = `${getLocationOrigin()}/buddy/add_buddy/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                        'buddy_details': details,
                                        'venue': venue
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response=>{  
          console.log('response',response)
          alert(response.message)
          window.location.reload()
          // props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

  handleChange(event) {
      const name = event.target.name;
      const target = event.target
      const value = target.type === 'checkbox' ? target.checked : target.value
      console.log(name,value)
      var new_value =  Object.assign({}, this.state.buddy_details);


      if (name=="display_name"){
        var temp_no = event.target.value.split(":");
        if (temp_no.length == 2){
             temp_no = temp_no.pop();
            if(temp_no.length != 10){
                new_value[name] = temp_no;
                new_value["mobile_no"] = "";
                new_value["name"] = "";
                new_value["user_id"] = "";
                this.setState({value_set:false})
            }
            else{
                new_value[name] = value
            }
        }
        else{
            new_value[name] = value
        }
      }
      else{
        new_value[name] = value
      }
      this.setState({buddy_details: new_value});
      // this.getAmount(this.state.equipment_details)
  }

  handleSubmit(event) {
      console.log('handle')
      event.preventDefault();
      console.log('Submit');
      this.postUpdateBooking(this.state.buddy_details,this.state.venue,this.props)
    }

  handleUserSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_user/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'user_name': this.state.buddy_details.name,
                        'user_mobile': this.state.buddy_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.buddy_details);
          cust.push({'id': data.user.id, 'name': data.user.name, 'mobile_no':data.user.mobile_no});
          this.setState({user_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
    }

    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search_user/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({user_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    searchUser() {
      {this.state.buddy_details.display_name?this.getSearchList(this.state.buddy_details.display_name):
        alert('Search cannot be blank')}
    }

    setSearch(name, customer_id, mobile_no){
      var new_selected_one =  Object.assign({}, this.state.buddy_details);
      new_selected_one['user_id'] = customer_id
      new_selected_one['mobile_no'] = mobile_no
      new_selected_one['name'] = name 
      new_selected_one['display_name'] = `${name}:${mobile_no}`;
      this.setState({buddy_details: new_selected_one, search: false,value_set:true});
    }

    handleClose = () => {
      this.setState({dialog_open_cust:false});
    };
    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        this.state.temp_list_game.push(optionsList.pk)
        var new_value =  Object.assign({}, this.state.buddy_details);
        new_value['games'] = this.state.temp_list_game
        this.setState({ buddy_details: new_value});

    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      var new_value =  Object.assign({}, this.state.buddy_details);
      new_value['games'] = dataItem.map(x => x.pk)
      this.setState({buddy_details:new_value});

    }


  
    render() {
      console.log('amount')
      console.log('venue',this.state.venue)
      console.log(this.state.buddy_details);
      console.log(this.state.search)
      

      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleUserSubmit}
        />,
      ];

      return(
        <div style={styles.container}> 

          <div className="row col-md-8 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              Add Buddy
            </div>
           
              <form  className="validated-form form-horizontal">
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header}  className="col-md-6">
                    User No
                  </div>
                  <div className="col-md-6 input-group">
                    <input type="text" name="display_name" value={this.state.buddy_details.display_name} className="col-md-8 form-control"
                      placeholder="Search for user"  onChange={this.handleChange} style={{ backgroundColor: this.state.value_set ? '#3CB3E2': 'white'}}/>
                    <span className="input-group-btn">
                      <button className="btn btn-default glyphicon glyphicon-search"
                      type="button" onClick={this.searchUser}></button>
                    </span>
                  </div>
                </div>
                {this.state.search?
              <div className="col-md-12 btn-group">
                {this.state.user_search_list.length?this.state.user_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
            :
            <div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
            <div className="alert alert-danger">Search user not found</div>
            <div>
                <RaisedButton
                  onClick={this.handleOpen}
                  label="Add"
                  style={{float:'right'}}
                  secondary={true}
                />
                <Dialog
                  actions={actions}
                  modal={false}
                  open={this.state.dialog_open_cust}
                  onRequestClose={this.handleClose}
                >
                  <div>
                      <div style={styles.main_header} className="col-md-12">
                          <h3 style={{textAlign:'center'}}>Add New User</h3>
                        </div>
                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Name
                              </div>
                              <input type="text" style={styles.input} name="name" className="required"
                                value={this.state.value} onChange={this.handleChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Mobile No
                              </div>
                            <input type="number" style={styles.input} name="mobile_no" className="required"
                              value={this.state.buddy_details.mobile_no} onChange={this.handleChange}/>
                          </div>
                        </div>
                      </Dialog>
                    
                    </div>

                    </div>
                }</div>:''

              }

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Role
                </div>
               <select name="role" className="col-md-6" style={styles.item_body}
                 onChange={this.handleChange}>
                  {
                     Object.keys(this.state.role_arr).map((key,index)=>(
                       <option key={key} value={key}>{this.state.role_arr[key]}</option>
                      ))
                   }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Department
                </div>
               <select name="department" className="col-md-6" style={styles.item_body}
                 onChange={this.handleChange}>
                  { 
                     Object.keys(this.state.departments_arr).map((key,index)=>(
                       <option key={key} value={key}>{this.state.departments_arr[key]}</option>
                      ))
                  }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">Is active ? </div>
                  <div style={styles.item_header,{padding:'0%'}} className="col-md-6"><input type='checkbox' name='is_active' onChange={this.handleChange}/></div>
              </div>
              
              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Game Types
                  </div>
                  <div style={styles.item_body} className="col-md-6">
                      <Multiselect
                        placeholder="Game Types"
                        data={this.state.game_types}
                        textField='name'
                        onSelect={this.onSelect} 
                        onChange={this.onChange}
                        filter='contains' 
                       />
                  </div>      

              </div>
             
              <div style={{ padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit}/>
                </div>
              </div>
                
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default AddBuddy;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addBuddy/AddBuddy.js